import { DynamicColumnHeader, OptionLuongThanhPhan } from "../luong/Luong";

export class DuLieuQuyetToanThueResponse {
    "idNhanVien": number;
    "maNhanVien": string;
    "hoTen": string;
    "idNhomNhanSu": number;
    "tenNhomNhanSu": string;
    "idChucVu": number;
    "tenChucVu": string;
    "banThan": number;
    "phuThuoc": number;
    "soNguoiPhuThuoc": number;
    "tongBaoHiem": number;
    "thuNhapTinhThueTNCN": number;
    "thuePhaiNop": number;
    "tongCongGiamTru": number;
    "thueConPhaiNop": number;
    "thueDuocHoanTra": number;
    "tongThuNhapChiuThue": number;
    "thuNhapChiuThuePhatSinh": Array<ThuNhapChiuThueResponse>;
    "cacKhoanGiamTru": Array<ThuNhapChiuThueResponse>;
    "dsThueTNCNDaNop": Array<ThuNhapChiuThueResponse>;
    "uyQuyenQT": boolean;
    "isNhanSuKhac": boolean
};

export class DuLieuThueThangKhongThuongXuyenResponse {
    "idNhanVien": number;
    "maNhanVien": string;
    "hoTen": string;
    "idChucVu": string;
    "tenChucVu": string;
    "thuePhaiNop": number;
    "tongThuNhapChiuThue": number;
    "soTienThueDaDong"?: number;
    "soTienThuePhaiDong"?: number;
    "dynamicColumns": Array<ThuNhapChiuThueResponse>;
};

export class ThuNhapChiuThueResponse {
    "tenThuNhap": string;
    "mucThuNhap": number;
    "loai": number;
    "idKhoanThuNhap": number;
    "loaiKhoanThuNhap": number;
    "soTienThueDaDong"?: number;
    "soTienThuePhaiDong"?: number;
    "khongThuThue"?: boolean;
};

export class KyTinhThueResponse {
    "id": number;
    "thangNam": Date;
    "kyThue": string;
    "soNhanVien": number;
    "tongThuNhapChiuThue": number;
    "tongThuNhapTinhThueTNCN": number;
    "tongThuePhaiNop": number
};

export class KyTinhThueKhongThuongXuyenResponse {
    "id": number;
    "thangNam": Date;
    "kyThue": string;
    "soNhanVien": number;
    "tongThuePhaiNop": number
};

export class ChiTietThueThangKhongThuongXuyenResponse {
    "thangNam": Date;
    "loaiChuKy"?: number;
    "quy"?: number;
    "nam"?: number;
    "mucToiThieu"?: number;
    "dataChiTietThueThangResponses": Array<DuLieuThueThangKhongThuongXuyenResponse>;
    "khoaDieuChinh": number;
    "chiTietCacKhoan": ChiTietTinhThueThangKhongThuongXuyen;
}

export class ChiTietThueNamResponse {
    "nam": number;
    "dataChiTietThueNamResponses": Array<DuLieuQuyetToanThueResponse>;
    "khoaDieuChinh": number;
}

export class ChiTietTinhThueThangKhongThuongXuyen {
    "dsThuLaoTGV": Array<number>;
    "dsThuLaoKCT": Array<number>;
    "dsKhenThuong": Array<number>;
    "dsThueThanhPhan"?: Array<number>;
    "dsKhongThuThue"?: Array<number>;
    "mucToiThieu"?: number;
}

export class DsOptionsTinhThueThangKhongThuongXuyen {
    "optionThuLaoKCT": Array<OptionLuongThanhPhan>;
    "optionThuLaoTGV": Array<OptionLuongThanhPhan>;
    "optionLuongKhenThuongNSK": Array<OptionLuongThanhPhan>;
    "optionThueThanhPhan"?: Array<OptionLuongThanhPhan>;
}

export class DsThueNamResponse {
    "id": number;
    "nam": number;
    "soNhanVien": number;
    "kyThue": string;    
    "tongThuePhaiNop": number;
    "khoaDieuChinh": number;
}

export class TongHopThueKTXNamResponse {
    "idNhanSuKhac": number;
    "hoTen": string;
    "idChucVu": number;
    "tenChucVu": string;
    "chiTietThueHangThang": Array<ChiTietThueKTXNamResponse>;
    "tongCong": number;
    "thueTNCN": number;
}

export class ChiTietThueKTXNamResponse {
    "tenThuNhap": string;
    "mucThuNhap": number;
}


// Nâng cấp  - THUẾ
export class DanhSachThueThangResponse {
    "id": number;
    "thangNam": Date | null;
    "quy": number;
    "nam": number;
    "loaiChuKy": number;
    "loai": number;
    "kieuTinh": number;
    "idThueTamTinh": number | null;
    "trangThai": number;
    "tenKyThue": string;
    "soNhanVien": number;
    "tongThuNhapChiuThue": number;
    "tongThuNhapTinhThueTNCN": number;
    "tongThuePhaiNop": number;
    "ngayKhoiTao": Date;
    "ngayCapNhat": Date | null;
    "tenNVKhoiTao": string | null;
}

export class ThueThangInfo {
    "id": number;
    "thangNam": Date | null;
    "tenKyThue": string | null;
    "loaiChuKy": number;
    "trangThai": number;
    "quy": number;
    "nam": number;
    "loai": number;
    "kieuTinh": number;
    "idThueTamTinh": number | null;
    "dsIdBHXH": number[];
    "dsIdThueTamTinh"?: number[];
    "dsIdLuongKhenThuongUngHo": number[];
    "dsIdLuongCoBan": number[];
    "dsIdLuongPhuCap": number[];
    "dsIdLuongThemGio": number[];
    "dsIdLuongHTNV": number[];
    "dsIdLuongBSTBKS": number[];
    "dsIdLuongThuLaoKCT": number[];
    "dsIdLuongPhuCapTGV": number[];
    "dsIdPhatSinhTinhThue"?: number[];
    "dynamicColumnHeaders": Array<DynamicColumnHeader> | null;
}

export class ChiTietThueThangItem {
    "id": number;
    "idThueThang": number;
    "loaiNhanSu": number;
    "idNhanVien"?: number | null;
    "idChucVu": number;
    "idDonVi": number;
    "tenChucVu": string;
    "tenDonVi": string;
    "idNhom": number;
    "tenNhom": string;
    "giamTruBanThan"?: number;
    "giamTruNguoiPhuThuoc"?: number;
    "soNguoiPhuThuoc"?: number;
    "thuNhapChiuThue": number;
    "tongCongGiamTru": number;
    "thuNhapTraChoCaNhan": number;
    "thuNhapTinhThue": number;
    "thuePhaiNop": number;
    "thueDaNop": number;
    "thueConPhaiNop": number;
    "ma": string;
    "hoTen": string;
    "ghiChu"?: string;
    "dynamicColumns"?: { [key: string]: number };
};

export class TongHopThueRequest {
    "dsIdThueTNCN"?: number[];
    "dsIdThueKTX"?: number[];
    "nam"?: number;
    "quy"?: number;
    "thangNam"?: string;
    "loaiChuKy"?: number;
    "tenKyThue"?: string;
    "idNVKhoiTao"?: number;
    "nguoiLap"?: string;
}

export class TongHopThueResponse {
    "dsThueTNCN": Array<ChiTietThueThangItem>;
    "dsThueKTX": Array<DuLieuThueThangKhongThuongXuyenResponse>;
    "dynamicColumnHeadersTNCN"?: Array<DynamicColumnHeader>;
    "tongThuNhapChiuThueTNCN": number;
    "tongThuePhaiNopTNCN": number;
    "tongThueDaNopTNCN": number;
    "tongThueConPhaiNopTNCN": number;
    "tongThuNhapChiuThueKTX": number;
    "tongThueTNCNKTX": number;
    "tongThuNhapChiuThueToanBo": number;
    "tongThueTNCNToanBo": number;
}

export class ThongTinThueTongHopResponse {
    "id": number;
    "thangNam": Date | null;
    "tenKyThue": string | null;
    "loaiChuKy": number;
    "trangThai": number;
    "quy": number;
    "nam": number;
    "loai": number;
    "khoaDieuChinh": number;
    "dsIdThueTNCN": number[];
    "dsIdThueKTX": number[];
    "ngayKhoiTao": Date;
    "ngayCapNhat": Date | null;
    "tenNVKhoiTao"?: string;
}

export class DuLieuChiTietThueTongHopResponse {
    "thongTin": ThongTinThueTongHopResponse;
    "dsThueTNCN": Array<ChiTietThueThangItem>;
    "dsThueKTX": Array<DuLieuThueThangKhongThuongXuyenResponse>;
    "dynamicColumnHeadersTNCN"?: Array<DynamicColumnHeader>;
    "tongThuNhapChiuThueTNCN": number;
    "tongThuePhaiNopTNCN": number;
    "tongThueDaNopTNCN": number;
    "tongThueConPhaiNopTNCN": number;
    "tongThuNhapChiuThueKTX": number;
    "tongThueTNCNKTX": number;
    "tongThuNhapChiuThueToanBo": number;
    "tongThueTNCNToanBo": number;
}

export class KhoiTaoThueTongHopRequest {
    "loaiChuKy": number;
    "thangNam": string;
    "dsIdThueTNCN"?: number[];
    "dsIdThueKTX"?: number[];
}

export class CapNhatThamChieuThueTongHopRequest {
    "idThueThang": number;
    "dsIdThueTNCN"?: number[];
    "dsIdThueKTX"?: number[];
}

export class LuuThueTongHopRequest {
    "idThueThang": number;
    "dsChiTietTNCN"?: Array<ChiTietThueThangItem>;
    "dsIdThueTNCN"?: number[];
    "dsIdThueKTX"?: number[];
}

